import { ReactNode } from 'react';
import { ICON_BUTTON_CLASS_NAME } from './styles';

interface IStartScreenProps {
  title: string;
  backLabel: string;
  onBack: () => void;
  footer?: ReactNode;
  children: ReactNode;
}

interface ISectionHeadingProps {
  id: string;
  count?: number;
  children: ReactNode;
}

export function SectionHeading({ id, count, children }: ISectionHeadingProps) {
  return (
    <div className="flex items-baseline justify-between px-[4px]">
      <h2 id={id} className="text-[13px] font-bold text-ink-muted">
        {children}
      </h2>
      {count != null && (
        <span
          aria-hidden="true"
          className="text-[13px] font-semibold text-ink-muted tabular-nums"
        >
          {count}
        </span>
      )}
    </div>
  );
}

export default function StartScreen({
  title,
  backLabel,
  onBack,
  footer,
  children,
}: IStartScreenProps) {
  return (
    <>
      <header className="relative z-30 flex h-[52px] shrink-0 items-center bg-header px-[6px] text-ink shadow-[inset_0_-1px_0_var(--color-hairline)]">
        <button
          aria-label={backLabel}
          onClick={onBack}
          className={ICON_BUTTON_CLASS_NAME}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M19 12H5M11 18l-6-6 6-6" />
          </svg>
        </button>
        <h1 className="absolute inset-x-[56px] truncate text-center text-[16px] font-bold tracking-[-0.2px]">
          {title}
        </h1>
      </header>
      <main className="relative min-h-0 flex-1 overflow-y-auto">
        <div className="mx-auto flex w-full max-w-[520px] flex-col gap-[20px] px-[12px] pt-[16px] pb-[24px]">
          {children}
        </div>
      </main>
      {footer && (
        <footer className="shrink-0 px-[10px] pb-[20px]">
          <div className="mx-auto flex max-w-[520px] items-center gap-[10px] rounded-[20px] bg-surface p-[8px] shadow-dock">
            {footer}
          </div>
        </footer>
      )}
    </>
  );
}
